module.exports = __webpack_public_path__ + "images/7d206dc0463159d67ecea455bd7158cb.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/og-image.png
// module id = 1096
// module chunks = 0